import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';
import { environment } from '../../environments/environment';
import { Flete, FletesRespSchema } from '../data/schemas/flete.schema';
import { Plant } from '../data/schemas/session.schema';

/** Planta activa y turno buscado; sin `turno` se consultan todos. */
export interface FletesFiltro {
  contexto: Pick<Plant, 'companyCode' | 'plantCode'>;
  turno?: number;
}

/** Fletes. */
export abstract class FletesDataService {
  abstract fletes(filtro: FletesFiltro): Observable<Flete[]>;
}

/**
 * Parámetros de paginación provisorios de `flete`. Desactivados: el backend todavía no los acepta
 * y responde 400 a parámetros desconocidos. Cuando los confirme, se activan acá.
 */
export const FLETE_PAGINACION = { enabled: false, limit: 'limit', offset: 'offset' } as const;

/** Implementación real: `GET /seed-backoffice/flete`, validado con Zod y sin fallback. */
@Injectable()
export class FletesApiService extends FletesDataService {
  private readonly http = inject(HttpClient);
  private readonly url = `${environment.apiUrl}/seed-backoffice/flete`;

  fletes({ contexto, turno }: FletesFiltro): Observable<Flete[]> {
    let params = new HttpParams().set('Empresa_Codigo', contexto.companyCode).set('Planta_Codigo', contexto.plantCode);
    if (turno != null) params = params.set('Nro_Turno', turno);
    return this.http.get<unknown>(this.url, { params }).pipe(map((res) => FletesRespSchema.parse(res)));
  }
}
